import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66945be6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "delete-modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Er du sikker på at du vil slette produktet?", -1))
const _hoisted_3 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_TextButton = _resolveComponent("TextButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.open)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('dismiss')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("header", null, [
              _hoisted_2,
              _createVNode(_component_TextButton, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dismiss')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SvgIcon, {
                    type: "mdi",
                    path: _ctx.closeIcon
                  }, null, 8, ["path"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("p", null, "Er du sikker på at du vil slette produktet \"" + _toDisplayString(_ctx.product.name) + "\"?", 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Button, {
                color: "red",
                onClick: _ctx.deleteProduct
              }, {
                default: _withCtx(() => [
                  (_ctx.deleteLoading)
                    ? (_openBlock(), _createBlock(_component_SvgIcon, {
                        key: 0,
                        type: "mdi",
                        path: _ctx.loadingIcon,
                        class: "animate-spin",
                        disabled: _ctx.deleteLoading
                      }, null, 8, ["path", "disabled"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Slett produkt ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                color: "gray",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('dismiss')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Avbryt")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}